import React, { Component } from 'react'
import $ from 'jquery';

class Auxbrowserfunc extends Component{    

    componentDidMount = () => {
        const auxheader = $("#aux-header");
        //handling page scroll aux header
        //class="scrolled"  
        $(document).scroll(function() {            
            window.innerWidth > 767 && $(this).scrollTop() > 162 ? auxheader.addClass("scrolled") : auxheader.removeClass("scrolled")
        })
    }

    render(){
        return(
            <React.Fragment></React.Fragment>
        );
    }
}

export default Auxbrowserfunc;